// Timezone mapping based on country and state
export const TIMEZONE_MAPPING = {
    // United States
    'United States': {
        'Alabama': 'America/Chicago',
        'Alaska': 'America/Anchorage',
        'Arizona': 'America/Phoenix',
        'Arkansas': 'America/Chicago',
        'California': 'America/Los_Angeles',
        'Colorado': 'America/Denver',
        'Connecticut': 'America/New_York',
        'Delaware': 'America/New_York',
        'Florida': 'America/New_York',
        'Georgia': 'America/New_York',
        'Hawaii': 'Pacific/Honolulu',
        'Idaho': 'America/Boise',
        'Illinois': 'America/Chicago',
        'Indiana': 'America/Indiana/Indianapolis',
        'Iowa': 'America/Chicago',
        'Kansas': 'America/Chicago',
        'Kentucky': 'America/New_York',
        'Louisiana': 'America/Chicago',
        'Maine': 'America/New_York',
        'Maryland': 'America/New_York',
        'Massachusetts': 'America/New_York',
        'Michigan': 'America/New_York',
        'Minnesota': 'America/Chicago',
        'Mississippi': 'America/Chicago',
        'Missouri': 'America/Chicago',
        'Montana': 'America/Denver',
        'Nebraska': 'America/Chicago',
        'Nevada': 'America/Los_Angeles',
        'New Hampshire': 'America/New_York',
        'New Jersey': 'America/New_York',
        'New Mexico': 'America/Denver',
        'New York': 'America/New_York',
        'North Carolina': 'America/New_York',
        'North Dakota': 'America/Chicago',
        'Ohio': 'America/New_York',
        'Oklahoma': 'America/Chicago',
        'Oregon': 'America/Los_Angeles',
        'Pennsylvania': 'America/New_York',
        'Rhode Island': 'America/New_York',
        'South Carolina': 'America/New_York',
        'South Dakota': 'America/Chicago',
        'Tennessee': 'America/Chicago',
        'Texas': 'America/Chicago',
        'Utah': 'America/Denver',
        'Vermont': 'America/New_York',
        'Virginia': 'America/New_York',
        'Washington': 'America/Los_Angeles',
        'West Virginia': 'America/New_York',
        'Wisconsin': 'America/Chicago',
        'Wyoming': 'America/Denver'
    },

    // India
    'India': {
        'Andhra Pradesh': 'Asia/Kolkata',
        'Arunachal Pradesh': 'Asia/Kolkata',
        'Assam': 'Asia/Kolkata',
        'Bihar': 'Asia/Kolkata',
        'Chhattisgarh': 'Asia/Kolkata',
        'Goa': 'Asia/Kolkata',
        'Gujarat': 'Asia/Kolkata',
        'Haryana': 'Asia/Kolkata',
        'Himachal Pradesh': 'Asia/Kolkata',
        'Jharkhand': 'Asia/Kolkata',
        'Karnataka': 'Asia/Kolkata',
        'Kerala': 'Asia/Kolkata',
        'Madhya Pradesh': 'Asia/Kolkata',
        'Maharashtra': 'Asia/Kolkata',
        'Manipur': 'Asia/Kolkata',
        'Meghalaya': 'Asia/Kolkata',
        'Mizoram': 'Asia/Kolkata',
        'Nagaland': 'Asia/Kolkata',
        'Odisha': 'Asia/Kolkata',
        'Punjab': 'Asia/Kolkata',
        'Rajasthan': 'Asia/Kolkata',
        'Sikkim': 'Asia/Kolkata',
        'Tamil Nadu': 'Asia/Kolkata',
        'Telangana': 'Asia/Kolkata',
        'Tripura': 'Asia/Kolkata',
        'Uttar Pradesh': 'Asia/Kolkata',
        'Uttarakhand': 'Asia/Kolkata',
        'West Bengal': 'Asia/Kolkata'
    },

    // Canada
    'Canada': {
        'Alberta': 'America/Edmonton',
        'British Columbia': 'America/Vancouver',
        'Manitoba': 'America/Winnipeg',
        'New Brunswick': 'America/Halifax',
        'Newfoundland and Labrador': 'America/St_Johns',
        'Nova Scotia': 'America/Halifax',
        'Ontario': 'America/Toronto',
        'Prince Edward Island': 'America/Halifax',
        'Quebec': 'America/Montreal',
        'Saskatchewan': 'America/Regina',
        'Northwest Territories': 'America/Yellowknife',
        'Nunavut': 'America/Iqaluit',
        'Yukon': 'America/Whitehorse'
    },

    // Australia
    'Australia': {
        'New South Wales': 'Australia/Sydney',
        'Victoria': 'Australia/Melbourne',
        'Queensland': 'Australia/Brisbane',
        'Western Australia': 'Australia/Perth',
        'South Australia': 'Australia/Adelaide',
        'Tasmania': 'Australia/Hobart',
        'Northern Territory': 'Australia/Darwin',
        'Australian Capital Territory': 'Australia/Sydney'
    },

    // United Kingdom
    'United Kingdom': {
        'England': 'Europe/London',
        'Scotland': 'Europe/London',
        'Wales': 'Europe/London',
        'Northern Ireland': 'Europe/London'
    },

    // Germany
    'Germany': {
        'Baden-Württemberg': 'Europe/Berlin',
        'Bavaria': 'Europe/Berlin',
        'Berlin': 'Europe/Berlin',
        'Brandenburg': 'Europe/Berlin',
        'Bremen': 'Europe/Berlin',
        'Hamburg': 'Europe/Berlin',
        'Hesse': 'Europe/Berlin',
        'Lower Saxony': 'Europe/Berlin',
        'Mecklenburg-Vorpommern': 'Europe/Berlin',
        'North Rhine-Westphalia': 'Europe/Berlin',
        'Rhineland-Palatinate': 'Europe/Berlin',
        'Saarland': 'Europe/Berlin',
        'Saxony': 'Europe/Berlin',
        'Saxony-Anhalt': 'Europe/Berlin',
        'Schleswig-Holstein': 'Europe/Berlin',
        'Thuringia': 'Europe/Berlin'
    },

    // France
    'France': {
        'Île-de-France': 'Europe/Paris',
        'Auvergne-Rhône-Alpes': 'Europe/Paris',
        'Nouvelle-Aquitaine': 'Europe/Paris',
        'Occitanie': 'Europe/Paris',
        'Hauts-de-France': 'Europe/Paris',
        'Grand Est': 'Europe/Paris',
        'Pays de la Loire': 'Europe/Paris',
        'Bretagne': 'Europe/Paris',
        'Centre-Val de Loire': 'Europe/Paris',
        'Bourgogne-Franche-Comté': 'Europe/Paris',
        'Normandie': 'Europe/Paris',
        'Provence-Alpes-Côte d\'Azur': 'Europe/Paris',
        'Corse': 'Europe/Paris'
    },

    // Japan
    'Japan': {
        'Hokkaido': 'Asia/Tokyo',
        'Tohoku': 'Asia/Tokyo',
        'Kanto': 'Asia/Tokyo',
        'Chubu': 'Asia/Tokyo',
        'Kansai': 'Asia/Tokyo',
        'Chugoku': 'Asia/Tokyo',
        'Shikoku': 'Asia/Tokyo',
        'Kyushu': 'Asia/Tokyo'
    },

    // China
    'China': {
        'Beijing': 'Asia/Shanghai',
        'Shanghai': 'Asia/Shanghai',
        'Guangdong': 'Asia/Shanghai',
        'Jiangsu': 'Asia/Shanghai',
        'Zhejiang': 'Asia/Shanghai',
        'Shandong': 'Asia/Shanghai',
        'Henan': 'Asia/Shanghai',
        'Sichuan': 'Asia/Shanghai',
        'Hubei': 'Asia/Shanghai',
        'Hunan': 'Asia/Shanghai',
        'Hebei': 'Asia/Shanghai',
        'Fujian': 'Asia/Shanghai',
        'Shaanxi': 'Asia/Shanghai',
        'Jiangxi': 'Asia/Shanghai',
        'Anhui': 'Asia/Shanghai',
        'Liaoning': 'Asia/Shanghai',
        'Heilongjiang': 'Asia/Shanghai',
        'Jilin': 'Asia/Shanghai',
        'Shanxi': 'Asia/Shanghai',
        'Gansu': 'Asia/Shanghai',
        'Qinghai': 'Asia/Shanghai',
        'Yunnan': 'Asia/Shanghai',
        'Guizhou': 'Asia/Shanghai',
        'Guangxi': 'Asia/Shanghai',
        'Hainan': 'Asia/Shanghai',
        'Tibet': 'Asia/Shanghai',
        'Xinjiang': 'Asia/Shanghai',
        'Inner Mongolia': 'Asia/Shanghai',
        'Ningxia': 'Asia/Shanghai',
        'Tianjin': 'Asia/Shanghai',
        'Chongqing': 'Asia/Shanghai'
    },

    // Singapore
    'Singapore': {
        'Central Region': 'Asia/Singapore',
        'East Region': 'Asia/Singapore',
        'North Region': 'Asia/Singapore',
        'North-East Region': 'Asia/Singapore',
        'West Region': 'Asia/Singapore'
    }
};

// Function to get timezone based on country and state
export function getTimezoneByLocation(country, state) {
    if (!country || !state) return null;

    const countryMapping = TIMEZONE_MAPPING[country];
    if (!countryMapping) return null;

    return countryMapping[state] || null;
}

// Function to get all available timezones for a country
export function getTimezonesByCountry(country) {
    if (!country) return [];

    const countryMapping = TIMEZONE_MAPPING[country];
    if (!countryMapping) return [];

    return Object.values(countryMapping);
}

// Function to get all available states for a country
export function getStatesByCountry(country) {
    if (!country) return [];

    const countryMapping = TIMEZONE_MAPPING[country];
    if (!countryMapping) return [];

    return Object.keys(countryMapping);
}

// Function to get timezone display name
export function getTimezoneDisplayName(timezone) {
    if (!timezone) return '';

    const timezoneNames = {
        'America/New_York': 'Eastern Time (ET)',
        'America/Chicago': 'Central Time (CT)',
        'America/Denver': 'Mountain Time (MT)',
        'America/Los_Angeles': 'Pacific Time (PT)',
        'America/Anchorage': 'Alaska Time (AKT)',
        'Pacific/Honolulu': 'Hawaii Time (HST)',
        'America/Toronto': 'Eastern Time (ET)',
        'America/Vancouver': 'Pacific Time (PT)',
        'Europe/London': 'Greenwich Mean Time (GMT)',
        'Europe/Paris': 'Central European Time (CET)',
        'Europe/Berlin': 'Central European Time (CET)',
        'Asia/Tokyo': 'Japan Standard Time (JST)',
        'Asia/Shanghai': 'China Standard Time (CST)',
        'Asia/Kolkata': 'India Standard Time (IST)',
        'Asia/Singapore': 'Singapore Time (SGT)',
        'Australia/Sydney': 'Australian Eastern Time (AET)',
        'Australia/Perth': 'Australian Western Time (AWT)'
    };

    return timezoneNames[timezone] || timezone;
}
